﻿var googleChartsLoaded = false;

function loadGoogleCharts() {
    return new Promise((resolve) => {
        google.charts.load('current', { 'packages': ['corechart'] });
        google.charts.setOnLoadCallback(function () {
            googleChartsLoaded = true;
            resolve();
        });
    });
}

const NewVehicles = {
    history: window.History,
    buildUpQueryString: function (nv_data) {
        const queryStringData = {};
        $.map(nv_data,
            function (value, key) {
                if (key === "isPageChange")
                    return;
                if (value) {
                    queryStringData[key] = value;
                }
            });
        return $.param(queryStringData).replace(/%5B%5D/g, "");
    },
    getData: function () {
        const dataArray = $("[data-one-link-new-vehicles-query-attributes] :input").serializeArray();
        const data = {};
        dataArray.map(function (item) {
            if (data[item.name]) {
                if (typeof (data[item.name]) === "string") {
                    data[item.name] = [data[item.name]];
                }
                data[item.name].push(item.value);
            } else {
                data[item.name] = item.value;
            }
        });

        // Get the active tab
        var tabValue = $("#new-vehicles-tab1, #new-vehicles-tab2, #new-vehicles-tab3").filter(".active").attr('id');
        // Add the active tab to the data
        data.tab = tabValue;
        data.FuelType = $('#FuelType').val() || null;
        return data;
    },
    updateResultsLogic: function (isPageChange) {
        const self = this;
        const data = self.getData();
        if (isPageChange) {
            data.isPageChange = true;
        }
        self.history.pushState(data, $("title").html(), location.pathname + "?" + self.buildUpQueryString(data));
        return data;
    },
    reloadQuery: function () {
        const self = this;
        const state = self.history.getState();
        $.get('/one-link-new-vehicles/query', state.data, function (response) {
            $('[data-one-link-new-vehicles-query-attributes]').replaceWith(response);
        });
    },
    reloadTable: function (state) {
        const self = this;
        $.get("/one-link-new-vehicles/table-results", state.data, function (response) {
            $('[data-one-link-new-vehicles-table-results]').replaceWith(response);
        });
    },
    getChartData: function (state) {
        const self = this;
        $.get("/one-link-new-vehicles/get-chart-data", state.data, function (response) {
            console.log("Inside getChartData of NewVehicles");
            console.log("new vehicles: " + response);
            self.drawChartForMonths(state.data.tab, response);
        });
    },
    updateState: function () {
        const self = this;
        self.reloadQuery();
        const state = self.history.getState();
        $.get('/one-link-new-vehicles/table-results', state.data, function (response) {
            $('[data-one-link-new-vehicles-table-results]').replaceWith(response);
        });
        self.getChartData(self.history.getState());
    },
    drawChartForMonths: function (tab, rawDataNewVehicles) {
        console.log("chart loaded: " + googleChartsLoaded);
        if (googleChartsLoaded) {
            if ($('#' + tab).hasClass('active')) {
                const self = this;
                var newVehiclesChartId = 'curve_chart-' + tab;
                self.drawChart(newVehiclesChartId, rawDataNewVehicles);
            }
        } else {
            // Set a timeout or some other method to wait until googleChartsLoaded becomes true
            setTimeout(() => this.drawChartForMonths(tab, rawDataNewVehicles), 1000);
        }
    },
    getParameterByName: function (name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },
    drawChart: function (newVehiclesChartId, rawDataNewVehicles) {
        const self = this;
        var columnNames = ['Month', 'Electric %', 'Hybrid %', 'Petrol %', 'Diesel %'];
        var selectedFuelType = (self.getParameterByName('FuelType') || 'all').toLowerCase();
        if (selectedFuelType !== 'all') {
            var fuelTypes = ['electric', 'hybrid', 'petrol', 'diesel'];
            var index = fuelTypes.indexOf(selectedFuelType);
            columnNames = ['Month', columnNames[index + 1]];
        }
        var newVehiclesChartData = [columnNames];
        for (var i = 0; i < rawDataNewVehicles.length; i++) {
            var dateParts = rawDataNewVehicles[i].monthYear.split(" ");
            var year = parseInt(dateParts[1]);
            var monthMapping = { Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5, Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11 };
            var month = monthMapping[dateParts[0]];
            var fuelTypeMapping = {
                'electric': 'ev',
                'hybrid': 'hyb',
                'petrol': 'petrol',
                'diesel': 'diesel'
            };

            if (selectedFuelType === 'all') {
                newVehiclesChartData.push([
                    new Date(year, month),
                    rawDataNewVehicles[i].evPercentage ? parseFloat(rawDataNewVehicles[i].evPercentage.toFixed(2)) : null,
                    rawDataNewVehicles[i].hybPercentage ? parseFloat(rawDataNewVehicles[i].hybPercentage.toFixed(2)) : null,
                    rawDataNewVehicles[i].petrolPercentage ? parseFloat(rawDataNewVehicles[i].petrolPercentage.toFixed(2)) : null,
                    rawDataNewVehicles[i].dieselPercentage ? parseFloat(rawDataNewVehicles[i].dieselPercentage.toFixed(2)) : null
                ]);
            } else if (rawDataNewVehicles[i].hasOwnProperty(fuelTypeMapping[selectedFuelType] + 'Percentage')) {
                newVehiclesChartData.push([
                    new Date(year, month),
                    rawDataNewVehicles[i][fuelTypeMapping[selectedFuelType] + 'Percentage'] ? parseFloat(rawDataNewVehicles[i][fuelTypeMapping[selectedFuelType] + 'Percentage'].toFixed(2)) : null
                ]);
            }
        }
        var newVehiclesData = google.visualization.arrayToDataTable(newVehiclesChartData);

        var options = {
            curveType: 'none',
            vAxis: { format: '#\'%\'' },
            hAxis: {
                format: 'MMM yyyy',
                slantedText: true, // Enable slanted text
                slantedTextAngle: 45, // Set the angle to 45 degrees
                ticks: newVehiclesData.getNumberOfRows() ? newVehiclesData.getDistinctValues(0) : []
            },
            legend: {
                position: 'top',
                alignment: 'start'
            },
            series: {
                0: { lineWidth: 1, pointSize: 5 },
                1: { lineWidth: 1, pointSize: 5 },
                2: { lineWidth: 1, pointSize: 5 },
                3: { lineWidth: 1, pointSize: 5 }
            },
            chartArea: {
                left: '5%',
                right: '5%',
                top: '10%',
                bottom: '15%',
                width: '100%',
                height: '82%'
            }
        };
        var newVehiclesChartDiv = document.getElementById(newVehiclesChartId);
        if (newVehiclesChartDiv) {
            // Create a chart instance
            var newVehiclesChart = new google.visualization.LineChart(newVehiclesChartDiv);

            // Clear the chart
            newVehiclesChart.clearChart();

            // Draw the chart with options and data.
            newVehiclesChart.draw(newVehiclesData, options);
        }
    },
    setupOneLinkNewVehicles: function () {
        const self = this;
        const FuelType = self.getParameterByName('FuelType');

        $(document)
            .on("change",
                "[data-one-link-new-vehicles-query-attributes] input, [data-one-link-new-vehicles-query-attributes] select",
                function () {
                    self.updateResultsLogic();
                }
            );

        $("#new-vehicles-tab1, #new-vehicles-tab2, #new-vehicles-tab3").on('click', function (e) {
            // Stop the browser from following the link
            e.preventDefault();

            // Show the tab
            $(this).tab('show');

            // Update URL
            let url = new URL(window.location.href);
            url.searchParams.set('tab', $(this).attr('id'));
            window.history.replaceState({}, '', url);
        });

        // Pass FuelType and VehicleType to getChartData
        self.getChartData({ data: { tab: 'new-vehicles-tab1', FuelType } });
        History.Adapter.bind(window, "statechange", function () {
            self.updateState();
        });

        window.updateResults = function () {
            self.updateResultsLogic();
        };

        // Extract tab parameter from URL
        const urlSearchParams = new URLSearchParams(window.location.search);
        let tab = urlSearchParams.get('tab');

        // If a tab parameter is found, set this tab to active. Otherwise, default to tab1
        if (tab) {
            $('#' + tab).tab('show');
        } else {
            tab = 'new-vehicles-tab1';
            $('#' + tab).tab('show');
        }

        $("#new-vehicles-tab1, #new-vehicles-tab2, #new-vehicles-tab3").on('shown.bs.tab', function (e) {
            const tab = $(this).attr('id');
            // Only fetch the chart data and reload the table after the tab has been shown
            if ($('#' + tab).hasClass('active')) {
                const state = { data: { tab: tab, FuelType: self.getParameterByName('FuelType') } }; // Fetch FuelType from the URL
                self.getChartData(state);
                self.reloadTable(state); // Update to pass full state
            }
        });

        $('#' + tab).tab('show'); // <-- Move here

        // Explicitly call getChartData and reloadTable for the initial tab
        const state = { data: { tab: tab, FuelType: self.getParameterByName('FuelType') } }; // Fetch FuelType from the URL
        self.getChartData(state);
        self.reloadTable(state); // Update to pass full state

        google.charts.load('current', { 'packages': ['corechart'] });
    },
};

// average lead times
const AverageLeadTimes = {
    history: window.History,
    buildUpQueryString: function (alt_data) {
        const queryStringData = {};
        $.map(alt_data,
            function (value, key) {
                if (key === "isPageChange")
                    return;
                if (value) {
                    queryStringData[key] = value;
                }
            });
        return $.param(queryStringData).replace(/%5B%5D/g, "");
    },
    getAverageLeadTimesData: function () {
        // Get the active tab
        var tabValue = $("#average-lead-times-tab1, #average-lead-times-tab2, #average-lead-times-tab3").filter(".active").attr('id');

        // Return a data object with the active tab
        return { tab: tabValue };
    },
    updateResultsAverageLeadTimesLogic: function (isPageChange) {
        const self = this;
        const data = self.getAverageLeadTimesData();
        if (isPageChange) {
            data.isPageChange = true;
        }
        self.history.pushState(data, $("title").html(), location.pathname + "?" + self.buildUpQueryString(data));
        return data;
    },
    getChartData: function (state) {
        const self = this;
        $.get("/one-link-average-lead-times/get-chart-data", state.data, function (response) {
            self.drawAverageLeadTimesChartForMonths(state.data.tab, response);
        });
    },
    updateAverageLeadTimeState: function () {
        const self = this;
        const state = self.history.getState();
        $.get('/one-link-average-lead-times/table-results', state.data, function (response) {
            $('[data-one-link-average-lead-times-table-results]').replaceWith(response);
        });
        self.getChartData(self.history.getState());
    },
    reloadTable: function (state) {
        const self = this;
        $.get("/one-link-average-lead-times/table-results", state.data, function (response) {
            $('[data-one-link-average-lead-times-table-results]').replaceWith(response);
        });
    },
    drawAverageLeadTimesChartForMonths: function (tab, rawData) {
        if (googleChartsLoaded) {
            if ($('#' + tab).hasClass('active')) {
                const self = this;
                var chartId = 'curve_chart-' + tab;
                self.drawAverageLeadTimesChart(chartId, rawData);
            }
        } else {
            setTimeout(() => this.drawAverageLeadTimesChartForMonths(tab, rawData), 1000);
        }
    },
    getParameterByName: function (name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },
    drawAverageLeadTimesChart: function (chartId, rawData) {
        var columnNames = ['Month', 'Lead time (days)'];
        var chartData = [columnNames];

        for (var i = 0; i < rawData.length; i++) {
            var dateParts = rawData[i].monthYear.split(" ");
            var year = parseInt(dateParts[1]);
            var monthMapping = { Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5, Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11 };
            var month = monthMapping[dateParts[0]];
            var leadTime = rawData[i].averageLeadTime ? parseFloat(rawData[i].averageLeadTime.toFixed(2)) : null;
            chartData.push([new Date(year, month), leadTime]); // Add lead time data
        }
        var data = google.visualization.arrayToDataTable(chartData);

        var options = {
            curveType: 'none',
            vAxis: { format: '#\' day(s)\'' },
            hAxis: {
                format: 'MMM yyyy',
                slantedText: true, // Enable slanted text
                slantedTextAngle: 45, // Set the angle to 45 degrees
                ticks: data.getNumberOfRows() ? data.getDistinctValues(0) : [] // return distinct values from the first column (0 index) of the data
            },
            legend: {
                position: 'top',
                alignment: 'start'
            },
            series: {
                0: { lineWidth: 1, pointSize: 5 },
                1: { lineWidth: 1, pointSize: 5 },
                2: { lineWidth: 1, pointSize: 5 },
                3: { lineWidth: 1, pointSize: 5 }
            },
            chartArea: {
                left: '7%',
                right: '5%',
                top: '10%',
                bottom: '15%',
                width: '100%',
                height: '82%'
            }
        };

        var chartDiv = document.getElementById(chartId);
        if (chartDiv) {
            // Create a chart instance
            var chart = new google.visualization.LineChart(chartDiv);

            // Clear the chart
            chart.clearChart();

            // Draw the chart with options and data.
            chart.draw(data, options);
        }
    },
    setupOneLinkAverageLeadTimes: function () {
        const self = this;
        $("#average-lead-times-tab1, #average-lead-times-tab2, #average-lead-times-tab3").on('click', function (e) {
            // Stop the browser from following the link
            e.preventDefault();

            // Show the tab
            $(this).tab('show');

            // Update URL
            let url = new URL(window.location.href);
            url.searchParams.set('tab', $(this).attr('id'));
            window.history.replaceState({}, '', url);
        });
        self.getChartData({ data: { tab: 'average-lead-times-tab1' } });
        History.Adapter.bind(window, "statechange", self.updateAverageLeadTimeState());
        window.updateResults = function () {
            self.updateResultsAverageLeadTimesLogic();
        };
        // Extract tab parameter from URL
        const urlSearchParams = new URLSearchParams(window.location.search);
        let tab = urlSearchParams.get('tab') || 'average-lead-times-tab1' || 'average-lead-times-tab2';

        // If a tab parameter is found, set this tab to active. Otherwise, default to tab1
        if (tab) {
            $('#' + tab).tab('show');
        } else {
            tab = 'average-lead-times-tab1';
            $('#' + tab).tab('show');
        }

        $("#average-lead-times-tab1, #average-lead-times-tab2, #average-lead-times-tab3").on('shown.bs.tab', function (e) {
            const tab = $(this).attr('id');
            // Only fetch the chart data after the tab has been shown
            if ($('#' + tab).hasClass('active')) {
                const state = { data: { tab: tab } }; 
                self.getChartData(state);
                self.reloadTable(state); // Update to pass full state
            }
        });

        $('#' + tab).tab('show'); 

        const state = { data: { tab: tab } }; 
        self.getChartData(state);
        setTimeout(function () { self.reloadTable(state); }, 200); // delay of 200ms
        google.charts.load('current', { 'packages': ['corechart'] });
    },
};


// Average age of fleet
const AverageAgeOfFleet = {
    history: window.History,
    buildUpQueryString: function (nv_data) {
        const queryStringData = {};
        $.map(nv_data,
            function (value, key) {
                if (key === "isPageChange")
                    return;
                if (value) {
                    queryStringData[key] = value;
                }
            });
        return $.param(queryStringData).replace(/%5B%5D/g, "");
    },

    getAverageAgeOfFleetData: function () {
        const dataArray = $("[data-one-link-average-age-of-fleet-query-attributes] :input").serializeArray();
        const data = {};
        dataArray.map(function (item) {
            if (data[item.name]) {
                if (typeof (data[item.name]) === "string") {
                    data[item.name] = [data[item.name]];
                }
                data[item.name].push(item.value);
            } else {
                data[item.name] = item.value;
            }
        });

        // Get the active tab
        var tabValue = $("#average-age-of-fleet-tab1, #average-age-of-fleet-tab2, #average-age-of-fleet-tab3").filter(".active").attr('id');
        // Add the active tab to the data
        data.tab = tabValue;
        data.VehicleType = $('#VehicleType').val() || null;
        return data;
    },

    updateResultsAverageAgeOfFleetLogic: function (isPageChange) {
        const self = this;
        const data = self.getAverageAgeOfFleetData();
        if (isPageChange) {
            data.isPageChange = true;
        }
        self.history.pushState(data, $("title").html(), location.pathname + "?" + self.buildUpQueryString(data));
        return data;
    },

    reloadQuery: function () {
        const self = this;
        const state = self.history.getState();
        $.get('/one-link-average-age-of-fleet-entering-workshop/query', state.data, function (response) {
            $('[data-one-link-average-age-of-fleet-query-attributes]').replaceWith(response);
        });
    },
    reloadTable: function (state) {
        const self = this;
        $.get("/one-link-average-age-of-fleet-entering-workshop/table-results", state.data, function (response) {
            $('[data-one-link-average-age-of-fleet-table-results]').replaceWith(response);
        });
    },
    getAverageAgeOfFleetChartData: function (state) {
        const self = this;
        $.get("/one-link-average-age-of-fleet-entering-workshop/get-chart-data", state.data, function (response) {
            console.log("Inside getAverageAgeOfFleetChartData of AverageAgeOfFleet");
            console.log("age: " + response);
            self.drawAverageAgeOfFleetChartForMonths(state.data.tab, response);
        });
    },

    updateAverageAgeOfFleetState: function () {
        const self = this;
        self.reloadQuery();
        const state = self.history.getState();
        $.get('/one-link-average-age-of-fleet-entering-workshop/table-results', state.data, function (response) {
            $('[data-one-link-average-age-of-fleet-table-results]').replaceWith(response);
        });
        self.getAverageAgeOfFleetChartData(self.history.getState());
    },

    drawAverageAgeOfFleetChartForMonths: function (tab, drawAverageAgeOfFleetChart) {
        
        
        if (googleChartsLoaded) {
            if ($('#' + tab).hasClass('active')) {
                const self = this;
                var ageOfFleetChartId = 'curve_chart-' + tab;
                self.drawAverageAgeOfFleetChart(ageOfFleetChartId, drawAverageAgeOfFleetChart);
            }
        } else {
            setTimeout(() => this.drawAverageAgeOfFleetChartForMonths(tab, drawAverageAgeOfFleetChart), 1000);
        }
    },

    getParameterByName: function (name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },

    drawAverageAgeOfFleetChart: function (ageOfFleetChartId, rawDataAverageAgeOfFleet) {
        const self = this;
        var columnNames = ['Month', 'Cars (years)', 'Vans (years)'];
        var selectedVehicleType = (self.getParameterByName('VehicleType') || 'all').toLowerCase();
        if (selectedVehicleType !== 'all') {
            var vehicleTypes = ['cars', 'vans'];
            var index = vehicleTypes.indexOf(selectedVehicleType);
            columnNames = ['Month', columnNames[index + 1]];
        }
        var chartData = [columnNames];

        for (var i = 0; i < rawDataAverageAgeOfFleet.length; i++) {
            var dateParts = rawDataAverageAgeOfFleet[i].monthYear.split(" ");
            var year = parseInt(dateParts[1]);
            var monthMapping = { Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5, Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11 };
            var month = monthMapping[dateParts[0]];
            var vehicleTypeMapping = {
                'cars': 'averageCarAge',
                'vans': 'averageVanAge'
            };

            if (selectedVehicleType === 'all') {
                chartData.push([
                    new Date(year, month),
                    rawDataAverageAgeOfFleet[i].averageCarAge ? parseFloat(rawDataAverageAgeOfFleet[i].averageCarAge.toFixed(2)) : null,
                    rawDataAverageAgeOfFleet[i].averageVanAge ? parseFloat(rawDataAverageAgeOfFleet[i].averageVanAge.toFixed(2)) : null
                ]);
            } else if (rawDataAverageAgeOfFleet[i].hasOwnProperty(vehicleTypeMapping[selectedVehicleType])) {
                chartData.push([
                    new Date(year, month),
                    rawDataAverageAgeOfFleet[i][vehicleTypeMapping[selectedVehicleType]] ? parseFloat(rawDataAverageAgeOfFleet[i][vehicleTypeMapping[selectedVehicleType]].toFixed(2)) : null
                ]);
            }

        }
        var data = google.visualization.arrayToDataTable(chartData);

        var options = {
            curveType: 'none',
            vAxis: { format: '#\' year(s)\'' },
            hAxis: {
                format: 'MMM yyyy',
                slantedText: true, // Enable slanted text
                slantedTextAngle: 45, // Set the angle to 45 degrees
                ticks: data.getNumberOfRows() ? data.getDistinctValues(0) : []
            },
            legend: {
                position: 'top',
                alignment: 'start'
            },
            series: {
                0: { lineWidth: 1, pointSize: 5 },
                1: { lineWidth: 1, pointSize: 5 },
                2: { lineWidth: 1, pointSize: 5 },
                3: { lineWidth: 1, pointSize: 5 }
            },
            chartArea: {
                left: '7%',
                right: '5%',
                top: '10%',
                bottom: '15%',
                width: '100%',
                height: '82%'
            }
        };

        var ageOfFleetChartDiv = document.getElementById(ageOfFleetChartId);
        if (ageOfFleetChartDiv) {
            // Create a chart instance
            var ageOfFleetChart = new google.visualization.LineChart(ageOfFleetChartDiv);

            // Clear the chart
            ageOfFleetChart.clearChart();

            // Draw the chart with options and data.
            ageOfFleetChart.draw(data, options);
        }
    },

    setupOneLinkAverageAgeOfFleet: function () {
        const self = this;
        const VehicleType = self.getParameterByName('VehicleType');
        $(document).on("change",
            "[data-one-link-average-age-of-fleet-query-attributes] input, [data-one-link-average-age-of-fleet-query-attributes] select",
            () => self.updateResultsAverageAgeOfFleetLogic());

        $("#average-age-of-fleet-tab1, #average-age-of-fleet-tab2, #average-age-of-fleet-tab3").on('click', function (e) {
            // Stop the browser from following the link
            e.preventDefault();

            // Show the tab
            $(this).tab('show');

            // Update URL
            let url = new URL(window.location.href);
            url.searchParams.set('tab', $(this).attr('id'));
            window.history.replaceState({}, '', url);
        });
        self.getAverageAgeOfFleetChartData({ data: { tab: 'average-age-of-fleet-tab1' }, VehicleType });
        History.Adapter.bind(window, "statechange", () => self.updateAverageAgeOfFleetState()); 
        window.updateResults = function () {
            self.updateResultsAverageAgeOfFleetLogic();
        };

        // Extract tab parameter from URL
        const urlSearchParams = new URLSearchParams(window.location.search);
        let tab = urlSearchParams.get('tab');

        // If a tab parameter is found, set this tab to active. Otherwise, default to tab1
        if (tab) {
            $('#' + tab).tab('show');
        } else {
            tab = 'average-age-of-fleet-tab1';
            $('#' + tab).tab('show');
        }

        $("#average-age-of-fleet-tab1, #average-age-of-fleet-tab2, #average-age-of-fleet-tab3").on('shown.bs.tab', function (e) {
            const tab = $(this).attr('id');
            // Only fetch the chart data after the tab has been shown
            if ($('#' + tab).hasClass('active')) {
                const state = { data: { tab: tab, VehicleType: self.getParameterByName('VehicleType') } }; // Fetch FuelType from the URL
                self.getAverageAgeOfFleetChartData(state);
                self.reloadTable(state); // Update to pass full state
            }
        });

        $('#' + tab).tab('show'); 

        // Explicitly call getChartData and reloadTable for the initial tab
        const state = { data: { tab: tab, VehicleType: self.getParameterByName('VehicleType') } }; // Fetch FuelType from the URL
        self.getAverageAgeOfFleetChartData(state);
        self.reloadTable(state); // Update to pass full state


        google.charts.load('current', { 'packages': ['corechart'] });
    },
};

// average fleet vehicle downtime
const AverageFleetVehicleDowntime = {
    history: window.History,
    buildUpQueryString: function (alt_data) {
        const queryStringData = {};
        $.map(alt_data,
            function (value, key) {
                if (key === "isPageChange")
                    return;
                if (value) {
                    queryStringData[key] = value;
                }
            });
        return $.param(queryStringData).replace(/%5B%5D/g, "");
    },
    getAverageFleetVehicleDowntimeData: function () {
        // Get the active tab
        var tabValue = $("#average-fleet-vehicle-downtime-tab1, #average-fleet-vehicle-downtime-tab2, #average-fleet-vehicle-downtime-tab3").filter(".active").attr('id');

        // Return a data object with the active tab
        return { tab: tabValue };
    },
    updateResultsAverageFleetVehicleDowntimeLogic: function (isPageChange) {
        const self = this;
        const data = self.getAverageFleetVehicleDowntimeData();
        if (isPageChange) {
            data.isPageChange = true;
        }
        self.history.pushState(data, $("title").html(), location.pathname + "?" + self.buildUpQueryString(data));
        return data;
    },
    getChartData: function (state) {
        const self = this;
        $.get("/one-link-average-fleet-vehicle-downtime/get-chart-data", state.data, function (response) {
            self.drawAverageFleetVehicleDowntimeChartForMonths(state.data.tab, response);
        });
    },
    reloadTable: function (state) {
        const self = this;
        $.get("/one-link-average-fleet-vehicle-downtime/table-results", state.data, function (response) {
            $('[data-one-link-average-fleet-vehicle-downtime-table-results]').replaceWith(response);
        });
    },
    updateAverageFleetVehicleDowntimeState: function () {
        const self = this;
        const state = self.history.getState();
        $.get('/one-link-average-fleet-vehicle-downtime/table-results', state.data, function (response) {
            $('[data-one-link-average-fleet-vehicle-downtime-table-results]').replaceWith(response);
        });
        self.getChartData(self.history.getState());
    },
    drawAverageFleetVehicleDowntimeChartForMonths: function (tab, rawData) {
        if (googleChartsLoaded) {
            if ($('#' + tab).hasClass('active')) {
                const self = this;
                var chartId = 'curve_chart-' + tab;
                self.drawAverageFleetVehicleDowntimeChart(chartId, rawData);
            }
        } else {
            setTimeout(() => this.drawAverageFleetVehicleDowntimeChartForMonths(tab, rawData), 1000);
        }
    },
    getParameterByName: function (name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },
    drawAverageFleetVehicleDowntimeChart: function (chartId, rawData) {
        var columnNames = ['Month', 'Avg days vehicle taken off road (days)'];
        var chartData = [columnNames];

        for (var i = 0; i < rawData.length; i++) {
            var dateParts = rawData[i].monthYear.split(" ");
            var year = parseInt(dateParts[1]);
            var monthMapping = { Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5, Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11 };
            var month = monthMapping[dateParts[0]];
            var vor = rawData[i].averageVOR ? parseFloat(rawData[i].averageVOR.toFixed(2)) : null;
            chartData.push([new Date(year, month), vor]); // Add 
        }
        var data = google.visualization.arrayToDataTable(chartData);

        var options = {
            curveType: 'none',
            vAxis: {
                minValue: 1.50,  // Minimum value
                maxValue: 2.00,  // Maximum value
                format: '#.00\' day(s)\''  // Added '.00' to display two decimal places
            },
            hAxis: {
                format: 'MMM yyyy',
                slantedText: true, // Enable slanted text
                slantedTextAngle: 45, // Set the angle to 45 degrees
                ticks: data.getNumberOfRows() ? data.getDistinctValues(0) : []
            },
            legend: {
                position: 'top',
                alignment: 'start'
            },
            series: {
                0: { lineWidth: 1, pointSize: 5 },
                1: { lineWidth: 1, pointSize: 5 },
                2: { lineWidth: 1, pointSize: 5 },
                3: { lineWidth: 1, pointSize: 5 }
            },
            chartArea: {
                left: '10%',
                right: '5%',
                top: '10%',
                bottom: '15%',
                width: '100%',
                height: '82%'
            }
        };

        var chartDiv = document.getElementById(chartId);
        if (chartDiv) {
            // Create a chart instance
            var chart = new google.visualization.LineChart(chartDiv);

            // Clear the chart
            chart.clearChart();

            // Draw the chart with options and data.
            chart.draw(data, options);
        }
    },
    setupOneLinkAverageFleetVehicleDowntime: function () {
        const self = this;
        $("#average-fleet-vehicle-downtime-tab1, #average-fleet-vehicle-downtime-tab2, #average-fleet-vehicle-downtime-tab3").on('click', function (e) {
            // Stop the browser from following the link
            e.preventDefault();

            // Show the tab
            $(this).tab('show');

            // Update URL
            let url = new URL(window.location.href);
            url.searchParams.set('tab', $(this).attr('id'));
            window.history.replaceState({}, '', url);
        });
        self.getChartData({ data: { tab: 'average-fleet-vehicle-downtime-tab1' } });
        History.Adapter.bind(window, "statechange", self.updateAverageFleetVehicleDowntimeState());
        window.updateResults = function () {
            self.updateResultsAverageFleetVehicleDowntimeLogic();
        };
        // Extract tab parameter from URL
        const urlSearchParams = new URLSearchParams(window.location.search);
        let tab = urlSearchParams.get('tab') || 'average-fleet-vehicle-downtime-tab1' || 'average-fleet-vehicle-downtime-tab2';

        // If a tab parameter is found, set this tab to active. Otherwise, default to tab1
        if (tab) {
            $('#' + tab).tab('show');
        } else {
            tab = 'average-fleet-vehicle-downtime-tab1';
            $('#' + tab).tab('show');
        }

        $("#average-fleet-vehicle-downtime-tab1, #average-fleet-vehicle-downtime-tab2, #average-fleet-vehicle-downtime-tab3").on('shown.bs.tab', function (e) {
            const tab = $(this).attr('id');
            // Only fetch the chart data after the tab has been shown
            if ($('#' + tab).hasClass('active')) {
                const state = { data: { tab: tab } };
                self.getChartData(state);
                self.reloadTable(state); // Update to pass full state
            }
        });

        $('#' + tab).tab('show'); // <-- Move here

        const state = { data: { tab: tab } };
        self.getChartData(state);
        setTimeout(function () { self.reloadTable(state); }, 200); // delay of 200ms

        google.charts.load('current', { 'packages': ['corechart'] });
    },
};


// Main entry point
$(function () {
    loadGoogleCharts().then(() => {
        const pageType = $("#PageType").val(); // Get the value of hidden field
        if (pageType === 'OneLinkNewVehicles') {
            NewVehicles.setupOneLinkNewVehicles();
        } else if (pageType === 'OneLinkAverageVehicleWorkshopLeadTime') {
            AverageLeadTimes.setupOneLinkAverageLeadTimes();
        }
        else if (pageType === 'OneLinkAverageAgeOfFleetEnteringWorkshop') {
            AverageAgeOfFleet.setupOneLinkAverageAgeOfFleet();
        }
        else if (pageType === 'OneLinkAverageFleetVehicleDowntime') {
            AverageFleetVehicleDowntime.setupOneLinkAverageFleetVehicleDowntime();
        }
    });
});

$(window).resize(function () {
    const pageType = $("#PageType").val();
    if (pageType === 'OneLinkNewVehicles') {
        const activeTab = $("#new-vehicles-tab1, #new-vehicles-tab2, #new-vehicles-tab3").filter(".active").attr('id');
        NewVehicles.getChartData({ data: { tab: activeTab } });
    } else if (pageType === 'OneLinkAverageVehicleWorkshopLeadTime') {
        const activeTab = $("#average-lead-times-tab1, #average-lead-times-tab2, #average-lead-times-tab3").filter(".active").attr('id');
        AverageLeadTimes.getChartData({ data: { tab: activeTab } });
    }
    else if (pageType === 'OneLinkAverageAgeOfFleetEnteringWorkshop') {
        const activeTab = $("#average-age-of-fleet-tab1, #average-age-of-fleet-tab2, #average-age-of-fleet-tab3").filter(".active").attr('id');
        AverageAgeOfFleet.getAverageAgeOfFleetChartData({ data: { tab: activeTab } });
    }
    else if (pageType === 'OneLinkAverageFleetVehicleDowntime') {
        const activeTab = $("#average-fleet-vehicle-downtime-tab1, #average-fleet-vehicle-downtime-tab2, #average-fleet-vehicle-downtime-tab3").filter(".active").attr('id');
        AverageFleetVehicleDowntime.getChartData({ data: { tab: activeTab } });
    }
});

export function setupOneLinkNewVehicles() {
    NewVehicles.setupOneLinkNewVehicles();
}

export function setupOneLinkAverageLeadTimes() {
    AverageLeadTimes.setupOneLinkAverageLeadTimes();
}

export function setupOneLinkAverageAgeOfFleet() {
    AverageAgeOfFleet.setupOneLinkAverageAgeOfFleet();
}

export function setupOneLinkAverageFleetVehicleDowntime() {
    AverageFleetVehicleDowntime.setupOneLinkAverageFleetVehicleDowntime();
}